import { SLIDING } from '../../utils';
import emptySolutions from '../../utils/pax/emptySolutions';
import emptySolutionsForCornerGuide from '../../utils/pax/emptySolutionsForCornerGuide';
/**
 * Get corner widths depending on selected depths.
 * @param form The form state.
 * @returns The solution widths.
 */
export const getCornerWidths = (form) => {
    const width = form.selectState?.size_depth_right?.selectedIndex === 1
        ? form.size_width_left_85
        : form.size_width_left_88;
    const width_adjacent = form.selectState?.size_depth_left?.selectedIndex === 1
        ? form.size_width_right_85
        : form.size_width_right_88;
    return [width, width_adjacent];
};
/**
 * Get the correct empty solution for the given params, single wall.
 */
export const getEmptySolution = (options) => {
    const solution = emptySolutions.find(s => s.depth === Number(options.size_depth) &&
        s.height === Number(options.size_height) &&
        s.width === Number(options.size_width));
    if (options.door_type === SLIDING) {
        return solution?.slidingDoor ? solution?.slidingDoor : solution?.vpc;
    }
    return solution?.vpc;
};
/**
 * Get the correct empty solution for the given params, corner wall.
 */
export const getEmptySolutionCornerGuide = (options) => {
    const size = options.selectState?.size_depth_right?.selectedIndex === 1
        ? options.size_width_left_85
        : options.size_width_left_88;
    const size_adjacent = options.selectState?.size_depth_left?.selectedIndex === 1
        ? options.size_width_right_85
        : options.size_width_right_88;
    const solutions = emptySolutionsForCornerGuide.find(s => s.depth1 === Number(options.size_depth_left) &&
        s.depth2 === Number(options.size_depth_right) &&
        s.height === Number(options.size_height) &&
        s.width1 === Number(size) &&
        s.width2 === Number(size_adjacent) &&
        s.vpc !== 'x');
    return solutions?.vpc;
};
/**
 * Format the product item using the retail unit item number.
 * For all purposes regarding availability etc. ruItemNo should be used.
 * If the ruItemNo does not exist, the item can not be used for retail communication.
 * @param product The product to format.
 * @returns
 */
export const formatProductForRetailUnit = (product) => {
    if (product.content?.itemType && product.content?.ruItemNo) {
        return { type: product.content.itemType.toString(), id: product.content.ruItemNo };
    }
    return null;
};
//# sourceMappingURL=utils.js.map